import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import { KebabMenu, StyledCard } from '../../../Base/Common/CommonUIComponents';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CustomTable } from '../../../Base/Common/CustomTable';
import { deleteAPI, getAPI, putAPI } from '../../../Base/API';
import { handleNotification } from '../../../Base/Notification';

class ExpediaConnections extends Component {

    constructor(props) {
        super(props);
        this.state = {
            block: true,
            connections: []
        }
    }

    componentDidMount() {
        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                }
                else if (data.response && data.response.length > 0 && data.response[0].notificationProfile && data.response[0].notificationProfile.callbackConfigs) {
                    this.setState({ connections: data.response[0].notificationProfile.callbackConfigs, error: errorMessage, block: false })
                }
                else {
                    this.setState({ connections: [], error: errorMessage, block: false });
                }
            }
            else {
                this.setState({ connections: [], error: errorMessage, block: false });
            }

        }, `/api/Rate/ConnectionManagement/v1/Expedia/notificationProfile/callbackConfigs`);
    }

    refreshToken = (id) => {
        this.setState({ block: true });

        putAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                }
                else {
                    if (data.response && data.response.length > 0 && data.response[0].refreshNotificationCallbackConfigSecret && data.response[0].refreshNotificationCallbackConfigSecret.secretExpirationDateTime) {
                        const { connections } = this.state;
                        const index = connections.findIndex(conn => conn.id === id);
                        if (index !== -1) {
                            const updated = [...connections];
                            updated[index].secretExpirationDateTime = data.response[0].refreshNotificationCallbackConfigSecret.secretExpirationDateTime
                            this.setState({ connections: updated, error: errorMessage, block: false });
                        }
                        else {
                            this.setState({ error: errorMessage, block: false });
                        }
                    }
                    else {
                        this.setState({ error: errorMessage, block: false });
                    }

                    handleNotification(data, <FormattedMessage id="ExpediaConnections.SuccessRefreshToken" />, <FormattedMessage id="General.Success" />)
                }
            }
            else {
                this.setState({ error: errorMessage, block: false });
            }

        }, `/api/Rate/ConnectionManagement/v1/Expedia/notificationProfile/callbackConfigs/${id}/refreshSecret?keepExistingSecretActive=false`);
    }

    removeConfig = (id) => {
        this.setState({ block: true });

        deleteAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                }
                else {
                    const { connections } = this.state;
                    const index = connections.findIndex(conn => conn.id === id);
                    if (index !== -1) {
                        connections.splice(index, 1);
                        this.setState({ connections, error: errorMessage, block: false });
                    }
                    else {
                        this.setState({ error: errorMessage, block: false });
                    }

                    handleNotification(data, <FormattedMessage id="ExpediaConnections.SuccessRemoveConnection" />, <FormattedMessage id="General.Success" />)
                }
            }
            else {
                this.setState({ error: errorMessage, block: false });
            }

        }, `/api/Rate/ConnectionManagement/v1/Expedia/notificationProfile/callbackConfigs/${id}`);
    }

    render() {
        const { block, error, connections } = this.state;

        const columns = [
            {
                dataField: 'id',
                text: this.props.intl.formatMessage({ id: "ExpediaConnections.Id" }),
                sort: true
            },
            {
                dataField: 'callbackUrl',
                text: this.props.intl.formatMessage({ id: "ExpediaConnections.CallbackUrl" }),
                sort: true
            },
            {
                dataField: 'secretExpirationDateTime',
                text: this.props.intl.formatMessage({ id: "ExpediaConnections.SecretExpirationDateTime" }),
                sort: true
            },
            {
                dataField: 'contactEmail',
                text: this.props.intl.formatMessage({ id: "ExpediaConnections.ContactEmail" }),
                sort: true
            },
            {
                text: this.props.intl.formatMessage({ id: "ExpediaConnections.Actions" }),
                formatter: (_, row) => <div style={{ display: 'flex', justifyContent: 'center' }}><KebabMenu extraFields={[{
                    function: _ => this.refreshToken(row.id),
                    text: "ExpediaConnections.RefreshToken",
                    icon: "fas fa-sync-alt mr-2"
                },
                {
                    function: _ => this.removeConfig(row.id),
                    text: "ExpediaConnections.RemoveConfig",
                    icon: "fas fa-trash-alt mr-2"
                }]} /></div>
            }
        ];

        return (
            <StyledCard title="ExpediaConnections.Title" block={block} error={error}>
                <Row>
                    <Col>
                        <CustomTable
                            data={connections}
                            columns={columns}
                            shadow={false}
                            search={true}
                            remote={false}
                            showTotal={true}
                        />
                    </Col>
                </Row>
            </StyledCard>
        );
    }
}

export default injectIntl(ExpediaConnections);